import React, { createContext, useContext } from "react";
export const Context = createContext(null);
export const ComposableContext = ({ children, ...otherProps }) => {
    const context = useContext(Context);
    return (React.createElement(Context.Provider, { ...context, value: { ...context, ...otherProps } }, children));
};
